import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApplicationForUser } from '../../../models/borrower-portal/application-for-user-model';
import { ApplicationTaskModel } from '../../../models/borrower-portal/application-task-model';

@Component({
    selector: 'tasks-website-link',
    templateUrl: './tasks-website-link.component.html',
    styleUrls: ['./tasks-website-link.component.scss'],
    standalone: false
})
export class TasksWebsiteLinkComponent implements OnInit {

  @Input() tasks: ApplicationTaskModel[] = [];
  @Input() application: ApplicationForUser;

  @Input() isSubmitted: boolean;

  @Output() openWebsiteLinkClicked = new EventEmitter<ApplicationTaskModel>();

  /** Tracks which task cards are expanded on mobile */
  protected expandedTaskIds = new Set<number>();

  constructor() { }

  ngOnInit(): void {
  }

  toggleTaskExpanded(taskId: number): void {
    if (this.expandedTaskIds.has(taskId)) {
      this.expandedTaskIds.delete(taskId);
    } else {
      this.expandedTaskIds.add(taskId);
    }
  }

  isTaskExpanded(taskId: number): boolean {
    return this.expandedTaskIds.has(taskId);
  }

  openWebsiteLinkModal = (task: ApplicationTaskModel) => {
    this.openWebsiteLinkClicked.emit(task);
  }
}
